//- ==================================================
//- JavaScript: Widget
//- ==================================================

(function () {

  'use strict';

  var mainClass = 'featured-gallery';

  fastScroll(mainClass);
  fullscreen(mainClass);

})();
